import { render, staticRenderFns } from "./AddSpecimenWeightBody.vue?vue&type=template&id=7696d938"
import script from "./AddSpecimenWeightBody.vue?vue&type=script&lang=js"
export * from "./AddSpecimenWeightBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports